import React from "react";

const ReleaseV4 = () => {
  return (
    <div className="release_content">
      <h3>Beta v1.2.0</h3>
      <p>Released on 20 July 2023</p>
      <h2>Landing Page Features & Enhacements</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            Introduction a new section in Navigation Bar as "Govern" which holds
            3 sections Classification,Glossary,Bulk Upload
          </span>
        </li>
        <li>
          {" "}
          <span>
            User based persona where in user having certain role will be able to
            see the corresponding sections in the landing page
          </span>
        </li>
      </ul>
      <h2>Classification Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            New Section where in User can be able to Create Classification,Tags.
            This tags will be later associated with the metadata
          </span>
        </li>
        <li>
          {" "}
          <span>
            We can also edit & delete respective tags & classification by
            providing information
          </span>
        </li>
        <li>
          {" "}
          <span>
            All the tags and associated classification are listed in a tabular
            view along with a header showing the tag numbers next to the
            selected classification.
          </span>
        </li>
      </ul>
      <h2>Glossary Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            New Section where in User can be able to Create Glossary,Terms
          </span>
        </li>
        <li>
          {" "}
          <span>
            We can also edit & delete respective terms & glossary by providing
            information
          </span>
        </li>
        <li>
          {" "}
          <span>
            All the terms and associated classification are listed in a tabular
            view along with a header showing the term numbers next to the
            glossary selected
          </span>
        </li>
        <li>
          {" "}
          <span>You can add and create parent child terms as well</span>
        </li>
      </ul>
      <h2>Bulk Upload Page</h2>
      <hr />
      <ul>
        <li>
          {" "}
          <span>
            We have introduced a new section called "Bulk Upload" where user can
            download the bulk datasets its associated columns edit it and upload
            the template
          </span>
        </li>
        <li>
          {" "}
          <span>
            Datasets can be downloaded based on the schema selection(multiple),
            On selection of schema will list down the associated datasets
          </span>
        </li>
        <li>
          {" "}
          <span>User can select multiple datasets for download</span>
        </li>
        <li>
          {" "}
          <span>
            You can upload the template as well after doing necessary chnages to
            the same file downloaded.
          </span>
        </li>
        <li>
          <span>
            Success and Failure message is captured inside a popup for more
            readability.
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ReleaseV4;
